import React from "react";
import ReactDOM from "react-dom";
import "./Modal.css";
// import auth_background from "../assets/auth_background.webp";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="aspetto-modal-overlay"

      //onClick={onClose}
    >
      <div className="aspetto-modal-container" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.getElementById("aspetto-modal-root")
  );
};

const ModalHeader = ({ children }) => (
  <div className="aspetto-modal-header">{children}</div>
);

const ModalContent = ({ children }) => (
  <div className="aspetto-modal-content">{children}</div>
);

const ModalFooter = ({ children }) => (
  <div className="aspetto-modal-footer">{children}</div>
);

export { Modal, ModalHeader, ModalContent, ModalFooter };
